import { getPrintBridgeBaseUrl, getPrintBridgeInstallScriptUrl } from "@/core/printing/print-bridge-client";

interface PrintBridgeAgentDownloadProps {
  bridgeConnected: boolean;
  compact?: boolean;
}

export function PrintBridgeAgentDownload({
  bridgeConnected,
  compact = false,
}: PrintBridgeAgentDownloadProps) {
  const installUrl = bridgeConnected
    ? getPrintBridgeInstallScriptUrl()
    : "/print-bridge/install-print-bridge.ps1";

  return (
    <div className={`${compact ? "" : "border rounded p-2 bg-light"}`}>
      {!compact && (
        <p className="small fw-semibold mb-1">Agent ITaaS Print Bridge</p>
      )}
      <p className="small text-muted mb-2">
        Installez l&apos;agent local pour imprimer en TSPL direct (sans Chrome).
        {bridgeConnected ? (
          <>
            {" "}
            Agent détecté sur <code>{getPrintBridgeBaseUrl()}</code>.
          </>
        ) : (
          <> Téléchargez puis exécutez le script PowerShell.</>
        )}
      </p>
      <a
        className="btn btn-outline-primary btn-sm"
        href={installUrl}
        download="install-itaas-print-bridge.ps1"
      >
        Télécharger l&apos;agent
      </a>
    </div>
  );
}
